module.exports = __webpack_public_path__ + "media/src/assets/Images/exit-9348efba026454bbcded5d3f45169696.svg";